import { render, staticRenderFns } from "./MortgageApplicationCard.vue?vue&type=template&id=12241a58"
import script from "./MortgageApplicationCard.vue?vue&type=script&lang=js"
export * from "./MortgageApplicationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports